import { startTransition, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import colors from '@rewardopl/styles/colors';

import Button from '@rewardopl/react-ui/button';

import { ButtonWrapper, ContentWrapper, PageWrapper, Title, Wave } from './index.styles';

import ScrollableSlides from './scrollable_slides';
import Slide from './slide';

import { scrollToChild } from '../../../utils/carousel';

import { configLoginLoadable } from '../../../store';

import onboarding1 from '../../../static/onboarding/onboarding-1.png';
import onboarding2 from '../../../static/onboarding/onboarding-2.png';

const slides = [
  {
    id: 1,
    fetchPriority: 'high',
    image: onboarding1,
    text: 'Welcome to BubbleJoy!',
  },
  {
    id: 2,
    image: onboarding2,
    text: 'Collect points, get rewards',
  },
] as const;

export default function OnboardingPage() {
  const navigate = useNavigate();
  const scrollContainer = useRef<HTMLDivElement>(null);
  const [currentChildIndex, onChildChange] = useState(0);
  useAtomValue(configLoginLoadable);

  function navigateToLogin() {
    startTransition(() => {
      navigate('/login');
    });
  }

  function scrollToNext() {
    if (!scrollContainer.current) {
      return;
    }

    scrollToChild(currentChildIndex + 1, scrollContainer.current);
  }

  return (
    <>
      <meta content={colors.primary} name="theme-color" />
      <PageWrapper>
        <Wave />
        <ContentWrapper>
          <Title>
            <T>Welcome to BubbleJoy!</T>
          </Title>
          <ScrollableSlides onChildChange={onChildChange} scrollContainer={scrollContainer}>
            {slides.map((slide) => (
              <Slide key={slide.id} {...slide} />
            ))}
          </ScrollableSlides>
          <ButtonWrapper>
            {currentChildIndex === slides.length - 1 ? (
              <Button className="primary" onClick={navigateToLogin}>
                <T>Let’s begin!</T>
              </Button>
            ) : (
              <Button className="primary" onClick={scrollToNext} type="button">
                <T>Next</T>
              </Button>
            )}
          </ButtonWrapper>
        </ContentWrapper>
      </PageWrapper>
    </>
  );
}
